module.exports = __webpack_public_path__ + "img/clip1.3b760cd3.svg";